<ticketing-draw-item-container [draw]="draw()">
  @switch (draw().state) {
    @case (DrawState.RegistrationOpen) {
      <ticketing-button
        appearance="primary"
        [routerLink]="['/draws', draw().id, 'pos', 'submission']"
      >
        <div class="flex mx-1 my-0.5">
          <div class="mr-2">Registrierungen aufnehmen</div>
          <fa-icon
            [icon]="faAddressCard"
            size="sm"
          />
        </div>
      </ticketing-button>
    }
    @case (DrawState.Drawn) {
      <ticketing-button
        appearance="primary"
        [routerLink]="['/draws', draw().id, 'pos', 'issueing']"
      >
        <div class="flex mx-1 my-0.5">
          <div class="mr-2">Karten ausgeben</div>
          <fa-icon
            [icon]="faTicket"
            size="sm"
          />
        </div>
      </ticketing-button>
    }
  }
</ticketing-draw-item-container>
